export default {
    component: 'dc_battery_charger',
    name: 'dc_battery_charger',
    fields: [{
        name: 'Plant ID',
        param: 'plant_id',
        type: 'number',
        required: true,
        identifier: true
      },
      {
        name: 'Block ID',
        param: 'block_id',
        type: 'number',
        required: true,
        identifier: true,
        description: `> Should always start from ID **"1"**`
      },
      {
        name: 'Inverter Room',
        param: 'inverter_room',
        type: 'number',
        required: true,
        identifier: true,
        description: `> For each block, room id should start from **"1"**`
      },
      {
        name: 'DC Battery Charger ID',
        param: 'dc_battery_charger_id',
        type: 'number',
        required: true,
        identifier: true,
        description: `> For each block-room, dc battery charger id  should start from **"1"**`
      },
      {
        name: 'Device Name',
        param: 'device_name',
        type: 'text',
        description: `> For each block device name should be unique`
      },
      {
        name: 'Make',
        param: 'make',
        type: 'text',
      }
    ]
  }
